const ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS = (() => {
  const LOCAL_STORAGE_KEY = 'orderTradeInLookupTokens';

  const getStoredTokenState = () => {
    try {
      return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  /**
   * Clear any saved token from local storage.
   */
  const clearSavedToken = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  /**
   * Get the active token, if any.
   * @returns {string | undefined} The active token or else `undefined`.
   */
  const getActiveToken = () => {
    const { activeToken, expiresAt } = getStoredTokenState() || {};
    if (expiresAt && new Date(expiresAt) < new Date()) {
      // Current token is known to be expired. 
      clearSavedToken();
      return undefined;
    }
    return activeToken;
  };

  /**
   * If there's an active token, then navigate to the order/trade-in results page. Otherwise do
   * nothing.
   */
  const navigateToActiveSession = () => {
    const { originalPathname, expiresAt } = getStoredTokenState() || {};
    if (expiresAt && new Date(expiresAt) < new Date()) {
      // Current token is known to be expired. 
      clearSavedToken();
    } else if (originalPathname) {
      window.location.pathname = originalPathname;
    }
  };

  /**
   * Save a refreshed token that was just retrieved with the
   * `getRefreshedOrderAndTradeInLookupToken` query.
   * @param {string} refreshedToken The refreshed token
   * @param {string} expiresAt The new expiration date as an ISO-8601 string
   */
  const saveRefreshedToken = (refreshedToken, expiresAt) => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({
        ...getStoredTokenState(),
        activeToken: refreshedToken,
        expiresAt,
      }),
    );
  };

  /**
   * If there's a token present in the query string, then save that token to `localStorage` and
   * remove it from the query string.
   */
  const saveTokenFromQueryString = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = searchParams.get('token');
    if (tokenFromUrl && tokenFromUrl !== getStoredTokenState()?.originalToken) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        originalToken: tokenFromUrl,
        originalPathname: window.location.pathname,
        activeToken: tokenFromUrl,
        // We don't know the expiration date yet, but we should get a concrete expiration date as
        // soon as we refresh this token, which we should do as soon as we request orders or
        // trade-ins.
        expiresAt: null,
      }));
    }
    // For increased security, get the token out of the query string now that we've stored it in
    // localStorage.
    updateQueryParams({ token: null });
  };

  return {
    clearSavedToken,
    getActiveToken,
    navigateToActiveSession,
    saveRefreshedToken,
    saveTokenFromQueryString,
  };
})();
